import Head from 'next/head';

export const CustomHead = () => (
  <Head>
    <meta name="robots" content="noindex" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no"
    />
    <meta
      name="apple-itunes-app"
      content="app-id=792750948, affiliate-data=ct=peloton-web-profile&pt=34104800"
    />
    <link rel="manifest" href="/manifest.json" crossOrigin="use-credentials" />
    <link rel="shortcut icon" href="/favicon.png" />
    <link rel="apple-touch-icon" href="/app-icon.png" id="apple-touch-icon" />
    <title>Peloton</title>
  </Head>
);
